import DeviceGroupingTypes from '../devices/deviceGroupingTypes.ts';

export const groupingTypeLocalizations = {
    [DeviceGroupingTypes[DeviceGroupingTypes.Common]]: 'Загальний',
    [DeviceGroupingTypes[DeviceGroupingTypes.Grouped]]: 'Груповий',
    [DeviceGroupingTypes[DeviceGroupingTypes.Distributed]]: 'Розподільчий',
};
